import React from 'react';
import { Button } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import useSelectItem from '../FlexyDatatableTable/useSelectItem';

export type RowSelectionAction = {
    label: string;
    icon: string;
    onClick: (items: Array<unknown>) => void;
};

export type FlexyDatatableSelectionActionProps = RowSelectionAction;

export const FlexyDatatableSelectionAction: React.FunctionComponent<FlexyDatatableSelectionActionProps> =
    function (props) {
        const { label, icon = null, onClick } = props;
        const { selectedItems } = useSelectItem();
        const handleOnClick = () => {
            onClick(selectedItems);
        };

        return (
            <Button
                color="inherit"
                onClick={handleOnClick}
                sx={{
                    color: 'primary.dark.contrastText',
                    display: 'flex',
                    gap: '5px',
                    alignItems: 'center',
                    fontSize: '13px',
                    fontWeight: '500;',
                    lineHeight: '20.8px',
                    textAlign: 'left',
                }}
            >
                {icon && <FaOptionIcon icon={['fad', icon as IconName]} />}
                {label}
            </Button>
        );
    };
